"use strict";

import PerformanceTimer from "/app/deps/hologram/assets/js/performance_timer.mjs";

const startTime = performance.now();

globalThis.Hologram.pageReachableFunctionDefs = (deps) => {
	const {
		Bitstring,
		ERTS,
		HologramBoxedError,
		HologramInterpreterError,
		Interpreter,
		MemoryStorage,
		Type,
		Utils,
	} = deps;

	Interpreter.defineElixirFunction(
		"AlchemistBlog.AboutPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.AboutPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/about");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogIndexPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogIndexPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/blog");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.SubscribeForm",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.SubscribeForm",
		"action",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.atom("email_changed"),
					Type.variablePattern("params_0"),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Hologram_Component["put_state/3"](
						context.vars.component_1,
						Type.atom("email"),
						Interpreter.dotOperator(
							Interpreter.dotOperator(
								context.vars.params_0,
								Type.atom("event"),
							),
							Type.atom("value"),
						),
					);
				},
			},
			{
				params: (context) => [
					Type.atom("first_name_changed"),
					Type.variablePattern("params_0"),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Hologram_Component["put_state/3"](
						context.vars.component_1,
						Type.atom("first_name"),
						Interpreter.dotOperator(
							Interpreter.dotOperator(
								context.vars.params_0,
								Type.atom("event"),
							),
							Type.atom("value"),
						),
					);
				},
			},
			{
				params: (context) => [
					Type.atom("submit"),
					Type.matchPlaceholder(),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Hologram_Component["put_command/3"](
						Elixir_Hologram_Component["put_state/3"](
							context.vars.component_1,
							Type.atom("error"),
							Type.bitstring(""),
						),
						Type.atom("subscribe"),
						Type.list([
							Type.tuple([
								Type.atom("email"),
								Interpreter.dotOperator(
									Interpreter.dotOperator(
										context.vars.component_1,
										Type.atom("state"),
									),
									Type.atom("email"),
								),
							]),
							Type.tuple([
								Type.atom("first_name"),
								Interpreter.dotOperator(
									Interpreter.dotOperator(
										context.vars.component_1,
										Type.atom("state"),
									),
									Type.atom("first_name"),
								),
							]),
						]),
					);
				},
			},
			{
				params: (context) => [
					Type.atom("subscribed"),
					Type.matchPlaceholder(),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Hologram_Component["put_state/3"](
						context.vars.component_1,
						Type.atom("status"),
						Type.bitstring("sent"),
					);
				},
			},
			{
				params: (context) => [
					Type.atom("subscribe_failed"),
					Type.variablePattern("params_0"),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Hologram_Component["put_state/3"](
						context.vars.component_1,
						Type.atom("error"),
						Interpreter.dotOperator(
							context.vars.params_0,
							Type.atom("message"),
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.SubscribeForm",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("section"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"rounded-2xl border border-line/60 bg-surface p-6",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.case(
													Erlang["==/2"](
														Interpreter.dotOperator(
															context.vars.vars_0,
															Type.atom("status"),
														),
														Type.bitstring("sent"),
													),
													[
														{
															match: Type.atom("false"),
															guards: [],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("h2"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"font-display text-2xl font-semibold text-ink",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("Letters from the Lab"),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("p"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("mt-2 text-muted"),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring(
																					"\n      New essays on Elixir, AI & the craft of code, distilled and sent when they're ready.\n    ",
																				),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("form"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("$submit"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("submit"),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"mt-5 flex flex-col gap-3",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("input"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("type"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("text"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("name"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("first_name"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("value"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("first_name"),
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("$change"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"first_name_changed",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("placeholder"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"First name (optional)",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"input input-lg w-full",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("input"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("type"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("email"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("name"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("email"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("value"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("email"),
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("$change"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("email_changed"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("placeholder"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"you@example.com",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("required"),
																						Type.list([]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"input input-lg w-full",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("button"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("type"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("submit"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"btn-mercury w-full rounded-full px-6 py-3.5 text-lg",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"\n        Subscribe\n      ",
																						),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Interpreter.case(
																		Erlang["/=/2"](
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("error"),
																			),
																			Type.bitstring(""),
																		),
																		[
																			{
																				match: Type.atom("false"),
																				guards: [],
																				body: (context) => {
																					return Type.atom("nil");
																				},
																			},
																			{
																				match: Type.atom("true"),
																				guards: [],
																				body: (context) => {
																					return Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n      "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("p"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"mt-2 text-sm text-rose",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("error"),
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n    "),
																						]),
																					]);
																				},
																			},
																		],
																		context,
																	),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("p"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"mt-2 text-xs text-muted",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring(
																					"No spam. Unsubscribe anytime.",
																				),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]);
															},
														},
														{
															match: Type.atom("true"),
															guards: [],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("h2"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"font-display text-2xl font-semibold text-ink",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("Almost there ✦"),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("p"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("mt-2 text-muted"),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring(
																					"\n      We've sent a confirmation link to your inbox. Open it to complete your subscription.\n    ",
																				),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]);
															},
														},
													],
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.HomePage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.HomePage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Layout",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("og_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("https://alchemist-labs.dev/"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("og_type"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.bitstring("website")]),
								]),
							]),
							Type.tuple([
								Type.atom("og_image"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("/images/og-default.png"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("og_description"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring(
											"A personal blog about Elixir, AI, technology and the craft of coding.",
										),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("og_title"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring(
											"Alchemist Labs · notes on Elixir, AI & code",
										),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_title"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring(
											"Alchemist Labs · notes on Elixir, AI & code",
										),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Layout",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([Type.atom("doctype"), Type.bitstring("html")]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("html"),
											Type.list([
												Type.tuple([
													Type.bitstring("lang"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("en"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("h-full bg-base"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-theme"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("dark"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("head"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("charset"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("utf-8"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("viewport"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"width=device-width, initial-scale=1",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/js/site.js"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("async"),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://www.googletagmanager.com/gtag/js?id=G-WPJDSQXW21",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/js/analytics.js"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("description"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_description"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:title"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_title"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:description"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_description"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:type"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_type"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:url"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_url"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("canonical"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_url"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:image"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_image"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:image:width"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("1200"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:image:height"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("630"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:site_name"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Alchemist Labs"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:card"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("summary_large_image"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:title"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_title"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:description"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_description"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:image"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_image"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("title"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("page_title"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("preconnect"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://fonts.googleapis.com",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("preconnect"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://fonts.gstatic.com",
																			),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("crossorigin"),
																	Type.list([]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Spectral:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Cormorant+Garamond:ital,wght@1,500;1,600&display=swap",
																			),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/assets/css/app.css"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("alternate"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("application/rss+xml"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("title"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Alchemist Labs"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/feed.xml"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("icon"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/favicon.ico"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("sizes"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("any"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("theme-color"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#0a0a0f"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("author"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Stefan Mojsilović"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("application/ld+json"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		'{"@context":"https://schema.org","@graph":[{"@id":"https://alchemist-labs.dev/#website","@type":"WebSite","description":"A personal blog about Elixir, AI, technology and the craft of coding.","name":"Alchemist Labs","publisher":{"@id":"https://alchemist-labs.dev/#organization"},"url":"https://alchemist-labs.dev/"},{"@id":"https://alchemist-labs.dev/#organization","@type":"Organization","logo":{"@type":"ImageObject","url":"https://alchemist-labs.dev/images/og-default.png"},"name":"Alchemist Labs","url":"https://alchemist-labs.dev/"},{"@id":"https://alchemist-labs.dev/#person","@type":"Person","image":"https://alchemist-labs.dev/images/og-default.png","name":"Stefan Mojsilović","sameAs":["https://github.com/Antikythera","https://www.linkedin.com/in/stefan-mojsilovi%C4%87-76687166/"],"url":"https://alchemist-labs.dev/"}]}',
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom("Elixir.Hologram.UI.Runtime"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("body"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"min-h-full text-ink antialiased flex flex-col font-body",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("atmos-gradient"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("canvas"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("atmos-canvas"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("header"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"border-b border-line/60 bg-surface/80 backdrop-blur sticky top-0 z-10",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("nav"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"mx-auto flex max-w-3xl items-center justify-between px-6 py-4",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom("Elixir.Hologram.UI.Link"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("to"),
																					Type.list([
																						Type.tuple([
																							Type.atom("expression"),
																							Type.tuple([
																								Type.atom(
																									"Elixir.AlchemistBlog.HomePage",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"group inline-flex items-baseline gap-2",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("span"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"logo-word text-xl font-semibold tracking-tight",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("data-text"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"Alchemist Labs",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Alchemist Labs"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"flex items-center gap-6 text-sm font-medium text-muted",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.HomePage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Home"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.BlogIndexPage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Blog"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.AboutPage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("About"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.NewsletterPage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Newsletter"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("button"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("type"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("button"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring(
																								"data-theme-toggle",
																							),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("1"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"Toggle light/dark theme",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"inline-flex items-center transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"hero-sun size-5 theme-icon-dark",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"hero-moon size-5 theme-icon-light",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("main"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"mx-auto w-full max-w-3xl flex-1 px-6 py-12",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("slot"),
																	Type.list([]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("footer"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"border-t border-line/60 bg-surface/60",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("div"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"mx-auto flex max-w-3xl flex-col gap-1 px-6 py-8 text-sm text-muted",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("p"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"font-display text-base text-ink",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Alchemist Labs"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("p"),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Transmuting ideas about Elixir, AI & technology into code.",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"mt-4 flex items-center gap-5",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"https://github.com/Antikythera",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("target"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("_blank"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("rel"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"noopener noreferrer",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("GitHub"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-muted transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"icon-github size-5",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("aria-hidden"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("true"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"https://www.linkedin.com/in/stefan-mojsilovi%C4%87-76687166/",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("target"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("_blank"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("rel"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"noopener noreferrer",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("LinkedIn"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-muted transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"icon-linkedin size-5",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("aria-hidden"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("true"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("/feed.xml"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("target"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("_blank"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("rel"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"noopener noreferrer",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("RSS feed"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-muted transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"icon-rss size-5",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("aria-hidden"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("true"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"mt-3 flex items-center gap-3 text-xs text-muted/70",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("span"),
																					Type.list([]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("For agents:"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("/llms.txt"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("llms.txt"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("/sitemap.md"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("sitemap.md"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("p"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"mt-2 text-xs text-muted/70",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Built with Phoenix, LiveView & Hologram.",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"__layout_module__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.atom("Elixir.AlchemistBlog.Layout");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"__layout_props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/newsletter");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("section"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("mx-auto max-w-xl text-center"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("p"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"text-sm font-medium uppercase tracking-[0.2em] text-brand",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("The Alchemist's Letter"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("h1"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mt-4 font-display text-4xl font-bold leading-tight text-ink sm:text-5xl",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"\n    Notes from the Workshop, distilled to their essence.\n  ",
															),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("p"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mx-auto mt-5 max-w-lg text-lg leading-relaxed text-muted",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    Raw experiments with "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("text-ink"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Elixir"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(", "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("text-ink"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("AI"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																",\n    and the craft of building things that last, boiled down to the ideas worth keeping.\n    No cadence promises, no filler. Just the distillate.\n  ",
															),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("mx-auto mt-10 max-w-xl"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("component"),
													Type.atom(
														"Elixir.AlchemistBlog.Components.SubscribeForm",
													),
													Type.list([
														Type.tuple([
															Type.bitstring("cid"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("page_subscribe"),
																]),
															]),
														]),
													]),
													Type.list([]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Commons.MapUtils",
		"put_nested",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("data_0"),
					Type.list([Type.variablePattern("key_1")]),
					Type.variablePattern("value_2"),
				],
				guards: [],
				body: (context) => {
					return Erlang_Maps["put/3"](
						context.vars.key_1,
						context.vars.value_2,
						context.vars.data_0,
					);
				},
			},
			{
				params: (context) => [
					Type.variablePattern("data_0"),
					Type.consPattern(
						Type.variablePattern("key_1"),
						Type.variablePattern("rest_2"),
					),
					Type.variablePattern("value_3"),
				],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Elixir_Map["get/3"](
							context.vars.data_0,
							context.vars.key_1,
							Type.map([]),
						),
						Type.variablePattern("nested_data_4"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Erlang_Maps["put/3"](
						context.vars.key_1,
						Elixir_Hologram_Commons_MapUtils["put_nested/3"](
							context.vars.nested_data_4,
							context.vars.rest_2,
							context.vars.value_3,
						),
						context.vars.data_0,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Component",
		"put_command",
		3,
		"public",
		[
			{
				params: (context) => [
					Interpreter.matchOperator(
						Type.variablePattern("component_0"),
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Hologram.Component")],
						]),
						context,
					),
					Type.variablePattern("name_1"),
					Type.variablePattern("params_2"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Map["merge/2"](
						context.vars.component_0,
						Type.map([
							[
								Type.atom("next_command"),
								Elixir_Hologram_Component_Command["__struct__/1"](
									Type.list([
										Type.tuple([Type.atom("target"), Type.atom("nil")]),
										Type.tuple([Type.atom("name"), context.vars.name_1]),
										Type.tuple([
											Type.atom("params"),
											Elixir_Map["new/1"](context.vars.params_2),
										]),
									]),
								),
							],
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Component",
		"put_state",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("component_0"),
					Type.variablePattern("keys_1"),
					Type.variablePattern("value_2"),
				],
				guards: [(context) => Erlang["is_list/1"](context.vars.keys_1)],
				body: (context) => {
					return Elixir_Map["merge/2"](
						context.vars.component_0,
						Type.map([
							[
								Type.atom("state"),
								Elixir_Hologram_Commons_MapUtils["put_nested/3"](
									Interpreter.dotOperator(
										context.vars.component_0,
										Type.atom("state"),
									),
									context.vars.keys_1,
									context.vars.value_2,
								),
							],
						]),
					);
				},
			},
			{
				params: (context) => [
					Interpreter.matchOperator(
						Type.variablePattern("component_1"),
						Type.map([[Type.atom("state"), Type.variablePattern("state_0")]]),
						context,
					),
					Type.variablePattern("key_2"),
					Type.variablePattern("value_3"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Map["merge/2"](
						context.vars.component_1,
						Type.map([
							[
								Type.atom("state"),
								Erlang_Maps["put/3"](
									context.vars.key_2,
									context.vars.value_3,
									context.vars.state_0,
								),
							],
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Router.Helpers",
		"page_bundle_path",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("page_digest_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(Type.string("/hologram/page-"), {
							type: "binary",
						}),
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.page_digest_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(".js"), { type: "binary" }),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("to"),
								Type.list([
									Type.atom("module"),
									Type.atom("string"),
									Type.atom("tuple"),
								]),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("style"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("rel"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("class"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_Hologram_Router_Helpers["page_path/1"](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("to"),
																	),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("class"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("rel"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("rel"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("style"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("style"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$pointerdown"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__prefetch_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$click"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__load_prefetched_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page_mounted?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_mounted?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_digest"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_digest"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("instance_id"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("instance_id"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("initial_page?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("initial_page?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("csrf_token"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("csrf_token"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_1"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_1;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_2"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_3"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'\n    globalThis.Hologram ??= {};\n    globalThis.Hologram._pendingJsInteropActions = [];\n    globalThis.Hologram.assetManifest = $ASSET_MANIFEST_JS_PLACEHOLDER;\n    globalThis.Hologram.csrfToken = "',
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("csrf_token"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'";\n    globalThis.Hologram.instanceId = "',
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("instance_id"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'";\n\n    globalThis.Hologram.dispatchAction = function(actionName, target, params) {\n      globalThis.Hologram._pendingJsInteropActions.push([actionName, target, params]);\n    }\n  ',
																		),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_4"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			"\n    \n      globalThis.Hologram.pageMountData = (deps) => {\n        const Type = deps.Type;\n        \n        return {\n          componentRegistry: $COMPONENT_REGISTRY_JS_PLACEHOLDER,\n          pageModule: $PAGE_MODULE_JS_PLACEHOLDER,\n          pageParams: $PAGE_PARAMS_JS_PLACEHOLDER,\n          selfEchoes: $SELF_ECHOES_JS_PLACEHOLDER,\n          subReceiptAdds: $SUB_RECEIPT_ADDS_JS_PLACEHOLDER,\n          subReceiptDrops: $SUB_RECEIPT_DROPS_JS_PLACEHOLDER\n        };\n      };\n    ",
																		),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_5"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_5;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_6"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_7"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"asset_path/1"
																					](
																						Type.bitstring(
																							"hologram/runtime.js",
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_8"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"page_bundle_path/1"
																					](
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("page_digest"),
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);
};

globalThis.Hologram.pageScriptLoaded = true;
document.dispatchEvent(new CustomEvent("hologram:pageScriptLoaded"));

console.debug(
	"Hologram: page script executed in",
	PerformanceTimer.diff(startTime),
);
